export const MESSAGE_FORM_SUBMIT = 'form--submit';
export const MESSAGE_FORM_SUBMIT_SENT = 'form--submit-sent';
export const MESSAGE_FORM_ON_RESULT = 'form--on-result';
export const MESSAGE_FORM_ON_ERROR = 'form--on-error';
export const MESSAGE_FORM_INVALID = 'form--invalid';
export const MESSAGE_FORM_INVALID_INPUT = 'form--invalid-input';
